.#{$namespace}-loading-parent--relative {
	position: relative;
}

.#{$namespace}-loading-mask {
	position: absolute;
	inset: 0;
	z-index: 2000;
	background-color: shade-color($white-color, 90%);
	margin: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 0.3s;

	&.is-fullscreen {
		position: fixed;
	}

	&__spinner {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		color: color-token(primary);
	}

	&__icon {
		font-size: 32px;

		&.is-loading {
			animation: #{$namespace}-loading-rotate 1.2s linear infinite;
		}
	}

	&__text {
		margin: 0;
		font-size: $font-size;
		color: color-token(primary);
	}
}

@keyframes #{$namespace}-loading-rotate {
	100% {
		transform: rotate(360deg);
	}
}
